import {
  getMaxScrollLeft,
  HORIZONTAL_SCROLL_EDGE_TOLERANCE
} from './horizontalScrollEdge';

const getTrackChildren = (track: HTMLElement): HTMLElement[] =>
  Array.from(track.children).filter(
    (child): child is HTMLElement => child instanceof HTMLElement
  );

const getItemScrollLeft = (
  container: HTMLElement,
  child: HTMLElement
): number => {
  const containerRect = container.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();

  return childRect.left - containerRect.left + container.scrollLeft;
};

/** Snap target: next flex item aligned to the container's left edge. */
export const getHorizontalScrollForwardTarget = (
  container: HTMLElement,
  track: HTMLElement
): number => {
  const { scrollLeft, scrollWidth, clientWidth } = container;
  const maxScrollLeft = getMaxScrollLeft(scrollWidth, clientWidth);

  for (const child of getTrackChildren(track)) {
    const itemLeft = getItemScrollLeft(container, child);

    if (itemLeft > scrollLeft + HORIZONTAL_SCROLL_EDGE_TOLERANCE) {
      return Math.min(itemLeft, maxScrollLeft);
    }
  }

  return maxScrollLeft;
};

/** Distance to scroll back to the previous item's left edge. */
export const getHorizontalScrollBackStep = (
  container: HTMLElement,
  track: HTMLElement
): number => {
  const { scrollLeft } = container;
  const children = getTrackChildren(track);

  for (let index = children.length - 1; index >= 0; index -= 1) {
    const itemLeft = getItemScrollLeft(container, children[index]);

    if (itemLeft < scrollLeft - HORIZONTAL_SCROLL_EDGE_TOLERANCE) {
      return scrollLeft - itemLeft;
    }
  }

  return scrollLeft;
};
